import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import './home.scss';
import video from "../Assets/K2BaseCampTrek.mp4";
import Aos from 'aos';
import 'aos/dist/aos.css';
import Slider1 from '../Assets/BarahValley.jpg';
import Slider2 from '../Assets/Batura.jpg';
import Slider3 from '../Assets/HimalayanBrownBear.webp';
import Slider4 from '../Assets/RushLake.jpg';
import Slider5 from '../Assets/Rakaposhi.jpg';
import Slider6 from '../Assets/ShingarlaLake.jpeg';
import Slider7 from '../Assets/K7.jpg';
import Slider8 from '../Assets/LadyFinger.jpeg';
import Slider9 from '../Assets/Masherbrum.jpeg';
import Slider10 from '../Assets/nangaparbat.jpeg';
import { 
  FiChevronRight, 
  FiMapPin, 
  FiCalendar, 
  FiUsers, 
  FiStar,
  FiArrowRight,
  FiShield,
  FiAward,
  FiGlobe,
  FiTrendingUp,
  FiSun,
  FiCloud,
  FiWind
} from 'react-icons/fi';
import { 
  FaMountain, 
  FaHiking, 
  FaHotel, 
  FaCarAlt,
  FaLeaf,
  FaHandsHelping,
  FaQuoteLeft,
  FaCheckCircle,
  FaUmbrellaBeach,
  FaSkiing
} from 'react-icons/fa';

const Home = () => {
  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);

  const sliderImages = [Slider1, Slider2, Slider3, Slider4, Slider5, Slider6, Slider7, Slider8, Slider9, Slider10];
  const [currentImage, setCurrentImage] = useState(0);
  const [typedText, setTypedText] = useState('');
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [currentCharIndex, setCurrentCharIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [activeTab, setActiveTab] = useState('treks'); // 'treks' or 'tours'

  const destinations = [
    "K2 Base Camp",
    "Hunza Valley", 
    "Fairy Meadows",
    "Skardu",
    "Nanga Parbat",
    "Baltoro Glacier"
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage(prev => (prev + 1) % sliderImages.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const typeWriter = () => {
      const currentWord = destinations[currentWordIndex];
      
      if (!isDeleting && currentCharIndex < currentWord.length) {
        setTypedText(currentWord.substring(0, currentCharIndex + 1));
        setCurrentCharIndex(currentCharIndex + 1);
      } else if (isDeleting && currentCharIndex > 0) {
        setTypedText(currentWord.substring(0, currentCharIndex - 1));
        setCurrentCharIndex(currentCharIndex - 1);
      } else if (!isDeleting && currentCharIndex === currentWord.length) {
        setTimeout(() => setIsDeleting(true), 2000);
      } else if (isDeleting && currentCharIndex === 0) {
        setIsDeleting(false);
        setCurrentWordIndex((currentWordIndex + 1) % destinations.length);
      }
    };

    const timer = setTimeout(typeWriter, isDeleting ? 50 : 100);
    return () => clearTimeout(timer);
  }, [currentCharIndex, isDeleting, currentWordIndex, destinations]);

  const stats = [
    { number: '5000+', label: 'Happy Travelers', icon: <FiUsers /> },
    { number: '10+', label: 'Years Experience', icon: <FiAward /> },
    { number: '50+', label: 'Destinations', icon: <FiMapPin /> },
    { number: '98%', label: 'Satisfaction Rate', icon: <FiStar /> }
  ];

  const features = [
    { icon: <FiShield />, text: 'Government Registered', subtext: 'License: DTS-GB-021' },
    { icon: <FaCheckCircle />, text: '24/7 Support', subtext: 'Always Available' },
    { icon: <FiGlobe />, text: 'International Guides', subtext: 'Multiple Languages' },
    { icon: <FaLeaf />, text: 'Eco-Friendly', subtext: 'Sustainable Tourism' }
  ];

  const trekInfo = {
    bestTime: 'May - September',
    difficulty: 'Easy to Extreme',
    accommodation: 'Hotels & Camps',
    season: 'Summer Treks'
  };

  const tourInfo = {
    spring: 'March - May',
    summer: 'June - September',
    autumn: 'October - November',
    winter: 'December - February',
    difficulty: 'Easy',
    accommodation: 'Hotels & Guest Houses',
    season: 'Year Round'
  };

  return (
    <>
      <Helmet>
        <title>World Adventures Tours | Explore Pakistan's Most Beautiful Treks</title>
        <meta name="description" content="Discover breathtaking destinations in Skardu, Hunza, Fairy Meadows and more. Trek with trusted guides and enjoy cultural relaxation across Pakistan." />
        <meta name="keywords" content="Pakistan tours, Skardu, Hunza, K2, trekking, adventure, travel agency, world adventures" />
        <meta name="author" content="World Adventures Tours" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta charSet="utf-8" />
        <meta property="og:title" content="World Adventures Tours | Premier Adventure Travel in Pakistan" />
        <meta property="og:description" content="Your trusted partner for unforgettable adventures in Pakistan's northern regions." />
        <meta property="og:type" content="website" />
      </Helmet>

      <section className='home'>
        <div className="hero-video-container">
          <video src={video} muted autoPlay loop playsInline></video>
          <div className="video-overlay"></div>
        </div>

        {/* Main Content */}
        <div className='homeContent'>
          <div className="container">
            <div className="content-wrapper">
              {/* Text Content */}
              <div className='text-content' data-aos="fade-up">
                <div className="badge">
                  <FiTrendingUp /> #1 Adventure Company in Pakistan
                </div>
                
                <h1 className='hero-title'>
                  Discover <span className="highlight">Pakistan's</span> 
                  <br />
                  <span className="typing-text">{typedText}</span>
                  <span className="cursor">|</span>
                </h1>
                
                <p className='hero-subtitle'>
                  Experience unforgettable adventures with expert guides in the world's most breathtaking mountains. 
                  From challenging treks to cultural explorations, we create journeys that last a lifetime.
                </p>

                {/* Stats */}
                <div className="stats-grid">
                  {stats.map((stat, index) => (
                    <div className="stat-item" key={index} data-aos="fade-up" data-aos-delay={index * 100}>
                      <div className="stat-icon">{stat.icon}</div>
                      <div className="stat-details">
                        <span className="stat-number">{stat.number}</span>
                        <span className="stat-label">{stat.label}</span>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Features */}
                <div className="features-grid">
                  {features.map((feature, index) => (
                    <div className="feature-item" key={index} data-aos="fade-up" data-aos-delay={index * 150}>
                      <div className="feature-icon">{feature.icon}</div>
                      <div className="feature-text">
                        <span className="feature-title">{feature.text}</span>
                        <span className="feature-subtext">{feature.subtext}</span>
                      </div>
                    </div>
                  ))}
                </div>

                {/* CTA Buttons */}
                <div className="cta-buttons" data-aos="fade-up" data-aos-delay="500">
                  <a href="/category/Challenging-treks" className="btn-primary">
                    Explore Treks <FiArrowRight />
                  </a>
                  <a href="/contact" className="btn-secondary">
                    <FiCalendar /> Book Consultation
                  </a>
                </div>
              </div>

              {/* Image Slider */}
              <div className="image-content" data-aos="fade-left">
                <div className="hero-slider-container">
                  <div className="slider-main">
                    <img 
                      src={sliderImages[currentImage]} 
                      alt="Pakistan Adventure" 
                      className="slider-image"
                    />
                    <div className="slider-overlay"></div>
                  </div>
                  
                  <div className="slider-thumbnails">
                    {sliderImages.slice(0, 4).map((img, index) => (
                      <div 
                        key={index} 
                        className={`thumbnail ${currentImage === index ? 'active' : ''}`}
                        onClick={() => setCurrentImage(index)}
                      >
                        <img src={img} alt={`Thumbnail ${index + 1}`} />
                      </div>
                    ))}
                  </div>

                  <div className="slider-info">
                    <div className="location-info">
                      <FiMapPin /> Gilgit-Baltistan, Pakistan
                    </div>
                    <div className="slider-counter">
                      {String(currentImage + 1).padStart(2, '0')} / {String(sliderImages.length).padStart(2, '0')}
                    </div>
                  </div>
                </div>

                {/* Updated Info Card with Tabs */}
                <div className="info-card" data-aos="fade-up" data-aos-delay="300">
                  <div className="info-header">
                    <FaMountain />
                    <h3>Quick Facts</h3>
                  </div>
                  
                  {/* Tab Navigation */}
                  <div className="info-tabs">
                    <button 
                      className={`tab-btn ${activeTab === 'treks' ? 'active' : ''}`}
                      onClick={() => setActiveTab('treks')}
                    >
                      <FaHiking /> Treks & Expeditions
                    </button>
                    <button 
                      className={`tab-btn ${activeTab === 'tours' ? 'active' : ''}`}
                      onClick={() => setActiveTab('tours')}
                    >
                      <FaUmbrellaBeach /> City Tours
                    </button>
                  </div>

                  {/* Trek Info Content */}
                  {activeTab === 'treks' && (
                    <div className="info-content trek-info">
                      <div className="info-item">
                        <FiCalendar />
                        <div>
                          <span className="info-label">Best Time for Treks</span>
                          <span className="info-value highlight">{trekInfo.bestTime}</span>
                          <span className="info-subtext">Peak trekking season</span>
                        </div>
                      </div>
                      <div className="info-item">
                        <FaHiking />
                        <div>
                          <span className="info-label">Difficulty Levels</span>
                          <span className="info-value">{trekInfo.difficulty}</span>
                          <span className="info-subtext">Varies by route</span>
                        </div>
                      </div>
                      <div className="info-item">
                        <FaHotel />
                        <div>
                          <span className="info-label">Accommodation</span>
                          <span className="info-value">{trekInfo.accommodation}</span>
                          <span className="info-subtext">{trekInfo.season}</span>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Tour Info Content */}
                  {activeTab === 'tours' && (
                    <div className="info-content tour-info">
                      <div className="seasonal-grid">
                        <div className="season-item">
                          <FiSun className="season-icon spring" />
                          <div>
                            <span className="season-label">Spring</span>
                            <span className="season-value">{tourInfo.spring}</span>
                          </div>
                        </div>
                        <div className="season-item">
                          <FiSun className="season-icon summer" />
                          <div>
                            <span className="season-label">Summer</span>
                            <span className="season-value">{tourInfo.summer}</span>
                          </div>
                        </div>
                        <div className="season-item">
                          <FiCloud className="season-icon autumn" />
                          <div>
                            <span className="season-label">Autumn</span>
                            <span className="season-value">{tourInfo.autumn}</span>
                          </div>
                        </div>
                        <div className="season-item">
                          <FiWind className="season-icon winter" />
                          <div>
                            <span className="season-label">Winter</span>
                            <span className="season-value">{tourInfo.winter}</span>
                          </div>
                        </div>
                      </div>
                      
                      <div className="tour-details">
                        <div className="info-item">
                          <FaHiking />
                          <div>
                            <span className="info-label">Difficulty Level</span>
                            <span className="info-value">{tourInfo.difficulty}</span>
                            <span className="info-subtext">Suitable for all ages</span>
                          </div>
                        </div>
                        <div className="info-item">
                          <FaHotel />
                          <div>
                            <span className="info-label">Accommodation</span>
                            <span className="info-value">{tourInfo.accommodation}</span>
                            <span className="info-subtext">{tourInfo.season}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className="scroll-indicator">
          <span>Scroll to explore</span>
          <div className="scroll-line"></div>
        </div>
      </section>
    </>
  );
};

export default Home;